module.exports = function (THREE) {
  let v6650 = new THREE.BoxGeometry(1, 1, 1);
  v6650.translate(0, 0.5, 0);
  let v6651 = new THREE.Mesh(v6650);
  let v6652 = new THREE.Mesh(new THREE.BoxGeometry(1, 1, 1));
  let v6653 = new THREE.PlaneGeometry(1, 1, 1, 1);
  let v6654 = new THREE.Mesh(v6653);
  return class {
    constructor(p7890, p7891, p7892) {
      this.index = p7890;
      this.buffers = p7891;
      this.data = p7892;
      this.uid = p7892.uid;
      this.offsets = {
        position: p7890 * 3,
        rotation: p7890 * 4,
        color: p7890 * 3,
        emissive: p7890 * 3,
        alphaTest: p7890 * 1,
        scale: p7890 * 3,
        opacity: p7890 * 1,
        visible: p7890 * 1,
        textureOffset: p7890 * 4,
        texture: p7890 * 1
      };
      this.rotation = new THREE.Quaternion();
      this.position = new THREE.Vector3();
      this.scale = new THREE.Vector3();
      this.visible = 1;
      this.textureOffset = [0, 0, 0, 0];
      this.texture = 0;
      this.color = new THREE.Color();
      this.emissive = new THREE.Color();
      this.alphaTest = 0;
      this.opacity = 1;
      this.active = true;
      this.inUse = true;
      this.init();
    }
    init() {
      this.color.set(this.data.color || "#ffffff");
      this.color.toArray(this.buffers.color, this.offsets.color);
      this.emissive.set(this.data.emissive || "#000000");
      this.emissive.toArray(this.buffers.emissive, this.offsets.emissive);
      this.textureOffset = this.data.texOff;
      this.buffers.textureOffset[this.offsets.textureOffset] = this.textureOffset[0];
      this.buffers.textureOffset[this.offsets.textureOffset + 1] = this.textureOffset[1];
      this.buffers.textureOffset[this.offsets.textureOffset + 2] = this.textureOffset[2];
      this.buffers.textureOffset[this.offsets.textureOffset + 3] = this.textureOffset[3];
      this.texture = this.data.tex;
      this.buffers.texture[this.offsets.texture] = this.texture;
      this.alphaTest = this.data.alphaTest ? this.data.alphaTest : 0;
      this.buffers.alphaTest[this.offsets.alphaTest] = this.alphaTest;
      this.opacity = this.data.opacity || 1;
      this.buffers.opacity[this.offsets.opacity] = this.opacity;
      this.visible = ~~(this.data.visible || 1);
      this.buffers.visible[this.offsets.visible] = this.visible;
      if (this.data.model) {
        v6652.position.set(this.data.x || 0, this.data.y || 0, this.data.z || 0);
        v6652.rotation.set(this.data.yR || 0, this.data.xR || 0, this.data.zR || 0);
        v6652.quaternion.normalize();
        this.rotation.copy(v6652.quaternion);
        this.position.copy(v6652.position);
        this.position.toArray(this.buffers.position, this.offsets.position);
        this.rotation.toArray(this.buffers.rotation, this.offsets.rotation);
        this.scale.set(this.data.w || 1, this.data.h || 1, this.data.l || 1);
        this.scale.toArray(this.buffers.scale, this.offsets.scale);
      } else if (this.data.type == 1) {
        v6654.position.set(this.data.x || 0, this.data.y || 0, this.data.z || 0);
        v6654.rotation.set((this.data.yR || 0) - Math.PI / 2, this.data.xR || 0, this.data.zR || 0);
        v6654.quaternion.normalize();
        this.rotation.copy(v6654.quaternion);
        this.position.copy(v6654.position);
        this.position.toArray(this.buffers.position, this.offsets.position);
        this.rotation.toArray(this.buffers.rotation, this.offsets.rotation);
        this.scale.set((this.data.w || 1) * 2, (this.data.l || 1) * 2, this.data.h || 1);
        this.scale.toArray(this.buffers.scale, this.offsets.scale);
      } else {
        v6651.position.set(this.data.x || 0, this.data.y || 0, this.data.z || 0);
        v6651.rotation.set(this.data.yR || 0, this.data.xR || 0, this.data.zR || 0);
        v6651.quaternion.normalize();
        this.rotation.copy(v6651.quaternion);
        this.position.copy(v6651.position);
        this.position.toArray(this.buffers.position, this.offsets.position);
        this.rotation.toArray(this.buffers.rotation, this.offsets.rotation);
        this.scale.set(this.data.w || 1, this.data.h || 1, this.data.l || 1);
        this.scale.toArray(this.buffers.scale, this.offsets.scale);
      }
    }
    visibility(p7893) {
      this.visible = ~~p7893;
      this.buffers.visible[this.offsets.visible] = this.visible;
    }
    updateTexture() {
      this.textureOffset = this.data.texOff;
      this.buffers.textureOffset[this.offsets.textureOffset] = this.textureOffset[0];
      this.buffers.textureOffset[this.offsets.textureOffset + 1] = this.textureOffset[1];
      this.buffers.textureOffset[this.offsets.textureOffset + 2] = this.textureOffset[2];
      this.buffers.textureOffset[this.offsets.textureOffset + 3] = this.textureOffset[3];
      this.texture = this.data.tex;
      this.buffers.texture[this.offsets.texture] = this.texture;
    }
    dispose() {
      this.active = false;
      this.inUse = false;
      this.visible = ~~false;
      this.buffers.visible[this.offsets.visible] = this.visible;
    }
  };
};